// extracted by mini-css-extract-plugin
export var errorsContainer = "_so-1";
export var link = "_so-0";